export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const getProperty = () => {
  return localStorage.getItem('property_id') || 'royal_tulip';
};

export const getPropertyConfig = () => {
  const config = localStorage.getItem('property_config');
  return config ? JSON.parse(config) : null;
};

export const setAuth = (token, user, propertyId) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  if (propertyId) {
    localStorage.setItem('property_id', propertyId);
  }
};

export const setPropertyConfig = (config) => {
  localStorage.setItem('property_config', JSON.stringify(config));
};

export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('property_id');
  localStorage.removeItem('property_config');
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const hasRole = (allowedRoles) => {
  const user = getUser();
  if (!user) return false;
  // Support both old single role and new roles array
  const userRoles = user.roles || (user.role ? [user.role] : []);
  return allowedRoles.some(role => userRoles.includes(role));
};